import React from 'react';
import {
  DesktopCTAButton,
  MobileCTAButton,
} from '@/components/shared/streamline/StreamlineControls';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { useIntl } from 'react-intl';

type GamesSectionHeaderProps = {
  title: string;
  categoryPath: string;
  totalGames: number;
};

function GamesSectionHeader({ title, categoryPath, totalGames }: GamesSectionHeaderProps) {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const buttonOnClick = () => {
    navigate(categoryPath);
  };
  return (
    <div className="flex flex-col md:flex-row md:items-end">
      <div className="border-b-2 border-blue-blue text-lg lg:text-xl font-extrabold text-black px-2 py-0">
        {title}
      </div>
      <div className="self-end">
        <DesktopCTAButton
          onClick={buttonOnClick}
          text={intl.formatMessage({ id: 'games.showAll' }) + ' (' + totalGames + ')'}
        />
        <MobileCTAButton
          onClick={buttonOnClick}
          text={intl.formatMessage({ id: 'games.showAll' }) + ' (' + totalGames + ')'}
        />
      </div>
    </div>
  );
}

export default GamesSectionHeader;
